import { useTranslation } from 'next-i18next/pages'
import type { PropsWithChildren } from 'react'

import {
  StyledChooseTypography,
  StyledContainer,
} from 'components/GenderFunnel/ChoiceCardPage/ChoiceCardPage.Styled'

type Props = {
  isMultiChoice?: boolean
}

export const ChoiceContainer = ({
  children,
  isMultiChoice = false,
}: PropsWithChildren<Props>) => {
  const { t } = useTranslation()
  return (
    <StyledContainer>
      {isMultiChoice && (
        <StyledChooseTypography $variant="Poppins/T2" $textAlign="center">
          {t('common_multi_choice_instruction')}
        </StyledChooseTypography>
      )}
      {children}
    </StyledContainer>
  )
}
